import { getCookie, setCookie } from './cookies';

export const HOVER_PREVIEW_GROUPS = Object.freeze({
    RECORDS: 'records',
    DOCUMENTS: 'documents',
});

export const HOVER_PREVIEW_PREFERENCE_EVENT = 'casedb:hover-preview-preference';

const COOKIE_NAMES = {
    [HOVER_PREVIEW_GROUPS.RECORDS]: 'case_hover_previews',
    [HOVER_PREVIEW_GROUPS.DOCUMENTS]: 'document_hover_previews',
};

export const getHoverPreviewPreference = (group) => {
    const cookieName = COOKIE_NAMES[group];
    return Boolean(cookieName) && getCookie(cookieName) === '1';
};

export const setHoverPreviewPreference = (group, enabled) => {
    const cookieName = COOKIE_NAMES[group];
    if (!cookieName) return true;

    const nextEnabled = Boolean(enabled);
    setCookie(cookieName, nextEnabled ? '1' : '0', 365);
    window.dispatchEvent(new CustomEvent(HOVER_PREVIEW_PREFERENCE_EVENT, {
        detail: { group, enabled: nextEnabled },
    }));
    return nextEnabled;
};

export const resetHoverPreviewPreference = (group) => {
    const cookieName = COOKIE_NAMES[group];
    if (!cookieName) return false;

    setHoverPreviewPreference(group, false);
    return false;
};
